import React from 'react';

interface YoutubeIconProps {
  className?: string;
}

function YoutubeIcon({ className }: YoutubeIconProps) {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none">
      <g clipPath="url(#a)">
        <path
          fill="currentColor"
          d="M19.588 5.2a2.505 2.505 0 0 0-1.763-1.763C16.26 3.01 10 3.01 10 3.01s-6.26 0-7.825.412A2.55 2.55 0 0 0 .412 5.2C0 6.765 0 10.01 0 10.01s0 3.262.412 4.81c.23.857.906 1.533 1.763 1.764 1.581.428 7.825.428 7.825.428s6.26 0 7.825-.412a2.506 2.506 0 0 0 1.763-1.763c.412-1.565.412-4.81.412-4.81s.016-3.262-.412-4.827z"
        />
        <path fill="#FCE9CF" d="m8.007 13.007 5.205-2.998-5.205-2.998v5.996z" />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h20v20H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default YoutubeIcon;
